var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4387 16.5785C13.4387 17.5051 14.1378 18.2562 15.0003 18.2562C15.8628 18.2562 16.5619 17.5051 16.5619 16.5785V11.5454C16.5619 10.6188 15.8628 9.8677 15.0003 9.8677C14.1378 9.8677 13.4387 10.6188 13.4387 11.5454V16.5785ZM16.5619 21.5928C16.5619 20.6662 15.8628 19.9151 15.0003 19.9151C14.1378 19.9151 13.4387 20.6662 13.4387 21.5928V21.6115C13.4387 22.5381 14.1378 23.2892 15.0003 23.2892C15.8628 23.2892 16.5619 22.5381 16.5619 21.6115V21.5928ZM10.9047 2.5888C12.6897 -0.862933 17.3104 -0.862933 19.0954 2.5888L29.4038 22.5227C31.1384 25.8774 28.8805 30 25.3084 30H4.69167C1.11948 30 -1.1385 25.8774 0.596299 22.5227L10.9047 2.5888Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.59fff6baeafeb9d2589d68bdaf665ac2.svg";
export { ForwardRef as ReactComponent };